import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, IconButton } from "@mui/material";
import { FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import settings from "../../helpers/Settings";
import Row from "react-bootstrap/Row";
import Cookies from "js-cookie";
import Col from "react-bootstrap/Col";
import axios from "axios";
import * as XLSX from "xlsx";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "react-bootstrap/Accordion";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
};
const allInsuraceCompanies = {
  "INS-FHIR": "Pseudo Payer",
  7001571327: "Bupa Arabia for Cooperative Insurance",
  7000911508: "The Cooperative Company for Cooperative Insurance",
  7001593321: "Al-Rajhi Company for Cooperative Insurance",
  7001548317:
    "The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)",
  7001539720: "Saudi Arabian Cooperative Insurance Company (SAICO) *",
  7001532279: "Gulf Union Cooperative Insurance Company",
  7001607683: "AXA Cooperative Insurance Company",
  7001519912: "Malath Cooperative Insurance and Reinsurance Company",
  7001559389: "United Cooperative Insurance Company",
  7001727200: "Tokyo Marine Development Corporation",
  7001527816: "Arabian Shield Cooperative Insurance Company *",
  7001617724: "Buruj Cooperative Insurance Company *",
  7001549059: "Trade Union Cooperative Insurance Company *",
  7001544472: "Al Sagr Cooperative Insurance Company *",
  7001641419: "Gulf General Company for Cooperative Insurance",
  7001609481: "Global Company for Cooperative Insurance",
  7001535694: "Allied Cooperative Insurance Group (ACIG)",
  7001526578: "Saudi United Cooperative Insurance Company (Wala",
  7001537161: "Allianz Saudi Fransi Cooperative Insurance Company",
  7001534275: "The National Company for Cooperative Insurance",
  7001626717: "Amana Cooperative Insurance Company *",
  7001625891: "Solidarity Saudi Takaful Company",
  7001703672: "Saudi Enaya Cooperative Insurance Company",
  7001523724: "Salama Cooperative Insurance Company",
  7001527667: "Arabia Insurance Cooperative Company",
};
class medicationList extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      searchInfo: {},
      searchLoading: false,
      selectedFile: "",
      extentionFile: false
    };
  }
  componentDidMount = async () => {
    this.getMedicationList();
  };
  onFileChange = (e) => {
    const allowedExtensions = ["xlsx"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        extentionFile: true,
      });
    } else
      this.setState({ selectedFile: e.target.files[0], fileMsg: "", extentionFile: false });

  };
  handleFileUpload = (e) => {
    if (!this.state.selectedFile && !this.state.extentionFile) {
      this.setState({
        fileMsg: "Make sure to select a file to upload"
      });
    } else if (!this.state.selectedFile && this.state.extentionFile) {
      this.setState({
        fileMsg: "It seems you've tried to upload a file with an unsupported extension. Currently, we only accept the following file types: .xlsx",
      });
    }
    else {
      this.setState({ fileMsg: "", extentionFile: false,uploadLoading:true })
      const reader = new FileReader();
      reader.readAsBinaryString(this.state.selectedFile);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet);
        let arr = [];
        for (let i = 0; i < parsedData.length; i++) {
          arr.push({
            providerid: parsedData[i]["Povider ID"],
            providername: parsedData[i]["Provider Name"],
            gtincode: parsedData[i]["Gtin"],
            description: parsedData[i]["Description"],
            price: parsedData[i]["Price"],
            category: parsedData[i]["Category"]
          });
        }
        // console.log(arr)
        this.setState({ originArr: arr })
        this.checkArray(arr, e);
        // this.sendReq(arr, e);

      };

    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
    this.setState({ selectedFile: "" })
  };
  sendReq = async (parsedData, e) => {
    // this.setState({ uploadLoading: true })
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/priceList/addMedication",
      {
        data: parsedData,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      if (data) {
        setTimeout(() => {
          this.setState({ uploadLoading: false });
        }, 1000);
        console.log('data:', data)
        if (data.success) {
          this.setState({ success: true, uploadModal: false, medicationList: [] });
          this.getMedicationList()
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  checkArray = (arr, e) => {
    let newArray = [];
    // console.log(arr,'here')
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i].gtincode || !arr[i].description
        || !arr[i].price || !arr[i].category)
        newArray.push(arr[i])
    }
    if (newArray && newArray.length > 0) {
      this.setState({ medicationList: newArray, newArray, uploadModal: false, fillValueMsg: "Please Fill These rows" })
    } else {
      this.setState({ medicationList: [], newArray: [], uploadModal: false, fillValueMsg: "" })
      // console.log('hhhhhhhhhhhhh')
      this.sendReq(arr, e)
    }
  }
  handleCheckBoxChange = (e) => {
    if (e.target.checked) {
      this.setState({ packagee: true });
    } else {
      this.setState({ packagee: false });
    }

  };
  deleteMedicationList = async (id) => {
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/pricelist/deleteMedicationList",
      {
        id: id,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );

    if (response) {
      let { data } = response;
      if (data.success) {
        this.getMedicationList();
        let { medicationList } = data;
        this.setState({ medicationList: medicationList });
      } else {
        let { error } = data;
        if (error) {
          this.setState({ error: error });
        }
      }
    }
  };
  closeUploadModal = () => {
    this.setState({
      uploadModal: false,
      selectedFile: "",
      fileMsg: ""
    });
  };
  updateMedicationList = async (e) => {
    let { newArray, originArr, elementSelected } = this.state;
    if (newArray && newArray.length > 0) {
      let i = originArr.indexOf(elementSelected);
      originArr[i].gtincode = this.state.gtincode;
      originArr[i].description = this.state.description;
      originArr[i].price = this.state.price;
      originArr[i].category = this.state.category;

      console.log(originArr[i], 'after modify')
      this.setState({ updateMedicationListModal: false })
      this.checkArray(originArr, e);
    } else {
      let response = await axios.put(
        KayanURL + "api/KSA/RCM/pricelist/updateMedicationList",
        {
          data: {
            id: this.state.id,
            gtincode: this.state.gtincode,
            description: this.state.description,
            price: this.state.price,
            category: this.state.category
          },
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        }
      );

      if (response) {
        let { data } = response;
        if (data.success) {
          this.getMedicationList();
          let { medicationList } = data;
          this.setState({ medicationList: medicationList, updateMedicationListModal: false });
        } else {
          let { error } = data;
          if (error) {
            this.setState({ error: error });
          }
        }
      }
    }

  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      searchInfo: { ...this.state.searchInfo, [name]: value },
      [name]: value,
      payerId: value
    });

  };
  getMedicationList = async () => {
    this.setState({
      spinnerFlag: true
    })
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/priceList/getAllMedication",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        this.setState({ spinnerFlag: false })
        if (data.success) {
          let { medicationList } = data;
          this.setState({ medicationList: medicationList });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  handleCloseMedicationListModal = () => {
    this.setState({ updateMedicationListModal: false });
  };
  handleUpdateMedicationList = async (element) => {
    this.setState({
      updateMedicationListModal: true,
    });
    if (element) {
      // console.log(element, 'selected')
      this.setState({
        id: element["id"],
        gtincode: element.gtincode,
        description: element.description,
        price: element.price,
        category: element.category,
        elementSelected: element
      });
    }
  };
  handleTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    let { medicationList } = this.state;
    let medicationListRows = [];
    if (medicationList && medicationList.length > 0) {
      medicationListRows = medicationList.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.providerid}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.providername}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.gtincode}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.description}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.price}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.category}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <div>
                <a style={{ cursor: "pointer", marginRight: "5px" }} onClick={() => this.handleUpdateMedicationList(element)}>
                  <EditIcon style={{ fontSize: "17px" }} />
                </a>
                <a style={{ cursor: "pointer" }} onClick={() => this.deleteMedicationList(element.id)}>
                  <DeleteIcon style={{ fontSize: "17px" }} />
                </a>

              </div>


            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <div>
        <div
          style={{
            textAlign: "center",
            margin: "auto",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
            marginTop: "50px",
            width: "95%",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <Button
              variant="contained"
              style={{
                backgroundColor: "rgb(97 110 120",
                border: "1px ridge gray",
                width: "25%",
                boxShadow: "none",
                height: "35px",
                color: "white",
                fontSize: "small",
                marginTop: "20px",
                marginRight: "10px"
              }}
              onClick={() => this.setState({ uploadModal: true })}
            >
              Upload Medication List File
            </Button>
          </div>
          {this.state.spinnerFlag ? (
            <CircularProgress />) :
            medicationList && medicationList.length > 0 ? (
              <>
                {this.state.fillValueMsg ? (
                  <h5 style={{ textAlign: "center", fontSize: "15px", marginTop: "20px", color: "red" }}>
                    {this.state.fillValueMsg}
                  </h5>
                ) : null}
                <TableContainer component={Paper} style={{ marginTop: "20px" }}>
                  <Table sx={{ minWidth: 100 }} aria-label="simple table">
                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                      <TableRow style={{ textAlign: "center" }}>
                        <TableCell align="center">Provider ID</TableCell>
                        <TableCell align="center">Provider Name</TableCell>
                        <TableCell align="center">GTIN Code</TableCell>
                        <TableCell align="center">Description</TableCell>
                        <TableCell align="center">Price</TableCell>
                        <TableCell align="center">Category</TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{medicationListRows}</TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              <h5 style={{ textAlign: "center", fontSize: "15px", marginTop: "20px", color: "red" }}>The Medication price list didn't uploaded yet, make sure to upload it.</h5>
            )}
          {this.state.uploadModal ? (
            <>
              <Modal
                open={this.state.uploadModal}
                onClose={this.closeUploadModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "30%",
                    height: "200px",
                    border: "1px solid white",
                    textAlign: "center",
                  }}
                >
                  <input
                    style={{
                      display: "block",
                      margin: "auto",
                      marginRight: "5px",
                    }}
                    type="file"
                    ref={this.fileInputRef}
                    onChange={this.onFileChange}
                  />
                  {this.state.fileMsg ? (
                    <>
                      <div style={{ textAlign: "center" }}>
                        <span
                          style={{
                            color: "red",
                            fontSize: "10px",
                          }}
                        >
                          {this.state.fileMsg}
                        </span>
                      </div>
                    </>
                  ) : null}

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(97 110 120",
                      border: "1px ridge gray",
                      width: "40%",
                      boxShadow: "none",
                      height: "35px",
                      color: "white",
                      fontSize: "small",
                      marginTop: "20px",
                      transition: "background-color 0.4s, color 0.4s",
                    }}
                    onClick={this.handleFileUpload}
                  >
                    {this.state.uploadLoading
                      ? "Loading..."
                      : "Upload File"}
                  </Button>
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.updateMedicationListModal ? (
            <>
              <Modal
                open={this.state.updateMedicationListModal}
                onClose={this.handleCloseMedicationListModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "30%",
                    height: "370px",
                    border: "1px solid white",
                  }}
                >
                  <Row>
                    <FormControl
                      sx={{ mb: 3 }} style={{ width: "100%" }}
                    >
                      <InputLabel
                        id="service type"
                        style={{ fontSize: "small" }}
                      >
                        Category
                      </InputLabel>
                      <Select
                        required
                        fullWidth
                        labelId="Category"
                        name="category"
                        label="Category"
                        value={this.state.category ? this.state.category : ""}
                        onChange={this.handleTextChange}
                        style={{ height: "45px" }}
                      >
                        <MenuItem
                          value="branded"
                          style={{ fontSize: "small" }}
                        >
                          Branded
                        </MenuItem>
                        <MenuItem
                          value="generic"
                          style={{ fontSize: "small" }}
                        >
                          Generic
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        name="gtincode"
                        label="Gtin Code"
                        variant="outlined"
                        onChange={this.handleTextChange}
                        value={
                          this.state.gtincode
                            ? this.state.gtincode
                            : ""
                        }
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        name="description"
                        label="Description"
                        variant="outlined"
                        onChange={this.handleTextChange}
                        value={
                          this.state.description
                            ? this.state.description
                            : ""
                        }
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        type="number"
                        required
                        name="price"
                        label="Price"
                        variant="outlined"
                        onChange={this.handleTextChange}
                        value={
                          this.state.price ? this.state.price : this.state.price == 0 ? this.state.price : null
                        }
                      />
                    </FormControl>



                  </Row>

                  <div style={{ textAlign: "center" }}>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={(e) => this.updateMedicationList(e)}
                      style={{
                        width: "30%",
                        marginTop: "10px",
                        backgroundColor: "rgb(97 110 120",
                        border: "1px solid rgb(97 110 120",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </Box>
              </Modal>
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

export default medicationList;
